'use client'

import { observeOnce } from '@susu/headless-commerce/utils/interserctionObserver'
import { isNull } from '@susu/null'
import type { ReactNode } from 'react'
import { useEffect, useRef } from 'react'

import styles from './TextAndImageRowBannerSection.module.scss'

export type DynamicMediaProps = {
  children?: ReactNode
}

const animatedClassName = 'halfcanvas-animation--animated'

export default function ClientDynamicMedia({
  children,
}: Readonly<DynamicMediaProps>) {
  const dynamicMediaWrapperRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const element = dynamicMediaWrapperRef.current

    if (!dynamicMediaWrapperRef?.current || isNull(element)) {
      return
    }

    observeOnce(dynamicMediaWrapperRef, () => {
      element.classList.add(animatedClassName)
    })
  }, [])

  return (
    <div
      className={styles['halfcanvas-animation']}
      ref={dynamicMediaWrapperRef}
    >
      {children}
    </div>
  )
}
